import React from 'react';
import { AiOutlineExclamationCircle } from 'react-icons/ai';

export default function NoContent() {
  return (
    <div className='no-content d-flex align-items-center justify-content-center'>
        <div className='my-5'>
          <AiOutlineExclamationCircle size={20} />
          <span className='ms-2'>No Data</span>
        </div>
    </div>
  )
}
